import "./App.css";
import { Provider } from "react-redux";
import { store } from "./stores/root";
import { BrowserRouter } from "react-router";
import { AuthHandler } from "./AuthHandler.tsx";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";

function App() {
  const ldClient = useLDClient();
  useEffect(() => {
    ldClient?.track("680964c2d2828d08efca51f8");
  }, [ldClient]);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthHandler />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
